import request from '@/utils/request'


// 查询账号等级列表
export function listLevel(query) {
  return request({
    url: '/account/level/list',
    method: 'get',
    params: query
  })
}

// 查询账号等级分页
export function pageLevel(query) {
  return request({
    url: '/account/level/page',
    method: 'get',
    params: query
  })
}

// 查询账号等级详细
export function getLevel(data) {
  return request({
    url: '/account/level/detail',
    method: 'get',
    params: data
  })
}

// 新增账号等级
export function addLevel(data) {
  return request({
    url: '/account/level/add',
    method: 'post',
    data: data
  })
}

// 修改账号等级
export function updateLevel(data) {
  return request({
    url: '/account/level/edit',
    method: 'post',
    data: data
  })
}

// 删除账号等级
export function delLevel(data) {
  return request({
    url: '/account/level/delete',
    method: 'post',
    data: data
  })
}
